import RpcClass from "../../../../../server/RpcClass.js";

import yaml from "js-yaml"

import RpcNotFoundException from "../../../../../server/com/silkplm/engine/rpc/exceptions/RpcNotFoundException.js";

let locale;
if(typeof window !== "undefined") {
    locale = window?.navigator?.userLanguage || window?.navigator?.language || Intl.DateTimeFormat().resolvedOptions().locale;
} else {
    locale= RpcClass.locale = Intl.DateTimeFormat().resolvedOptions().locale;
}

const FULL_CLASS = 'com.silkplm.model.plm.OrderDetails';

import LocalDate from "../../../../../server/LocalDate.js";
import LocalDateTime from "../../../../../server/LocalDateTime.js";
import LocalTime from "../../../../../server/LocalTime.js";



class OrderDetails extends RpcClass{

    /**
     *  @class OrderDetails
     *  @alias module:src/server/com/silkplm/model/plm/OrderDetails.OrderDetails
     *  
     * */
    constructor(){
        super();

        /** @type {string}  */
        this.EID = null;
        /** @type {LocalDate}  */
        this.ETA = null;
        /** @type {LocalDate}  */
        this.ETD = null;
        /** @type {LocalDate}  */
        this.EXWPI = null;
        /** @type {string}  */
        this.PM = null;
        /** @type {string}  */
        this.SKUNumber = null;
        /** @type {boolean}  */
        this.__archived = null;
        /** @type {number}  */
        this.__familyId = null;
        /** @type {boolean}  */
        this.__hidden = null;
        /** @type {number}  */
        this.__parent = null;
        /** @type {Date}  */
        this.__versionDate = null;
        /** @type {Object.<string, *>}  */
        this._translations = null;
        /** @type {module:src/server/com/silkplm/model/files/FileInRepository.FileInRepository[]}  */
        this.attachments = null;
        /** @type {string}  */
        this.budgetingPlannerPMId = null;
        /** @type {string}  */
        this.category = null;
        /** @type {string}  */
        this.colorId = null;
        /** @type {string}  */
        this.colorVersionId = null;
        /** @type {string}  */
        this.commentToShopify = null;
        /** @type {string}  */
        this.componentIndexId = null;
        /** @type {LocalDate}  */
        this.confirmedETD = null;
        /** @type {string}  */
        this.country = null;
        /** @type {string}  */
        this.currentSelectedRegion = null;
        /** @type {LocalDate}  */
        this.dateOfShipmentToTheCustomer = null;
        /** @type {string}  */
        this.defaultEAN = null;
        /** @type {LocalDate}  */
        this.deliveryDate = null;
        /** @type {LocalDate}  */
        this.deliveryDateDTW = null;
        /** @type {LocalDate}  */
        this.deliveryDateToNAOKOWarehouse = null;
        /** @type {string}  */
        this.designerDescription = null;
        /** @type {BigDecimal}  */
        this.duty = null;
        /** @type {module:src/server/com/silkplm/files/images/ImageGallery.ImageGallery}  */
        this.gallery = null;
        /** @type {string}  */
        this.id = null;
        /** @type {string}  */
        this.inspection = null;
        /** @type {string}  */
        this.merchant = null;
        /** @type {string}  */
        this.name = null;
        /** @type {LocalDate}  */
        this.newDTWDeliveryDate = null;
        /** @type {LocalDate}  */
        this.newDeliveryDateToNAOKOWarehouse = null;
        /** @type {string}  */
        this.notes = null;
        /** @type {string}  */
        this.orderId = null;
        /** @type {string}  */
        this.orderNumber = null;
        /** @type {number}  */
        this.orderedQuantity = null;
        /** @type {string}  */
        this.planningId = null;
        /** @type {string}  */
        this.port = null;
        /** @type {module:src/server/com/silkplm/rpc/dto/DecimalWithCurrency.DecimalWithCurrency}  */
        this.price = null;
        /** @type {string}  */
        this.productId = null;
        /** @type {string}  */
        this.productInSeasonId = null;
        /** @type {string}  */
        this.pzNumber = null;
        /** @type {number}  */
        this.pzQuantity = null;
        /** @type {string}  */
        this.quantityFromCuting = null;
        /** @type {boolean}  */
        this.rawMaterialsPath = null;
        /** @type {LocalDate}  */
        this.realEXW = null;
        /** @type {module:src/server/com/silkplm/engine/entities/tracking/RecordMetadata.RecordMetadata}  */
        this.recordMetadata = null;
        /** @type {LocalDate}  */
        this.shipmentDateToProcessing = null;
        /** @type {string}  */
        this.statusShipment = null;
        /** @type {string}  */
        this.statusShopifyId = null;
        /** @type {string}  */
        this.subSeasonId = null;
        /** @type {string}  */
        this.supplierProductId = null;
        /** @type {string}  */
        this.techDetailsId = null;
        /** @type {string}  */
        this.unitId = null;
        /** @type {number}  */
        this.version = null;

        if(window["SessionManager"]?.isLoggedIn()){
            const formConfig = window['FormsLoader']?.detectFormConfig(FULL_CLASS);
            for(const f of formConfig.fields){
                if(f.formDisabled){
                    continue;
                }
                if( f.defaultValue !== null) {
                    this[f.fieldName] = yaml.load(f.defaultValue);
                }
             }
        }
    }




    /**
     * Get list of detail Order Details Package Row
     * @returns {Promise<OrderDetailsPackageRow[]>}
     */

    async listOrderDetailsPackageRow(){
    return Rpc.Forms.listDetails(
        FULL_CLASS,
        this.id,
        "com.silkplm.model.plm.OrderDetailsPackageRow",
        "orderDetails");
    }
    /**
     * Get list of detail Additional Activity
     * @returns {Promise<AdditionalActivity[]>}
     */

    async listAdditionalActivity(){
    return Rpc.Forms.listDetails(
        FULL_CLASS,
        this.id,
        "com.silkplm.model.plm.AdditionalActivity",
        "orderDetailsId");
    }

    /** @type {number}  */
    get colorVersionIdColorVersionNumber(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['colorVersionIdColorVersionNumber'] : null, this.__metadata__['colorVersionIdColorVersionNumber']?.remoteType);
    }
    set colorVersionIdColorVersionNumber(val){
    }
    // fk: false

    /** @type {LocalDate}  */
    get orderIdDateOfOrderDispatch(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['orderIdDateOfOrderDispatch'] : null, this.__metadata__['orderIdDateOfOrderDispatch']?.remoteType);
    }
    set orderIdDateOfOrderDispatch(val){
    }
    // fk: false

    /** @type {number}  */
    get orderIdNumberOfOrder(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['orderIdNumberOfOrder'] : null, this.__metadata__['orderIdNumberOfOrder']?.remoteType);
    }
    set orderIdNumberOfOrder(val){
    }
    // fk: false

    /** @type {number}  */
    get productInSeasonIdProductIdNumberOfProduct(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['productInSeasonIdProductIdNumberOfProduct'] : null, this.__metadata__['productInSeasonIdProductIdNumberOfProduct']?.remoteType);
    }
    set productInSeasonIdProductIdNumberOfProduct(val){
    }
    // fk: false

    /** @type {boolean}  */
    get orderIdOrderForRawMaterials(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['orderIdOrderForRawMaterials'] : null, this.__metadata__['orderIdOrderForRawMaterials']?.remoteType);
    }
    set orderIdOrderForRawMaterials(val){
    }
    // fk: false

    /** @type {string}  */
    get productInSeasonIdSeasonId(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['productInSeasonIdSeasonId'] : null, this.__metadata__['productInSeasonIdSeasonId']?.remoteType);
    }
    set productInSeasonIdSeasonId(val){
    }
    // fk: true
    /** @returns {Promise<String>} */
    getProductInSeasonIdSeasonIdLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.Season', 'productInSeasonIdSeasonId',  allowRemote); //  false 
    }

    /** @returns {String} */
    getProductInSeasonIdSeasonIdStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.Season', 'productInSeasonIdSeasonId'); //  false 
    }

    /** @returns {Promise<Season>} */
    getProductInSeasonIdSeasonIdEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.Season', 'productInSeasonIdSeasonId',  allowRemote); //  false 
    }

    /** @type {string}  */
    get productInSeasonIdSubSeasonId(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['productInSeasonIdSubSeasonId'] : null, this.__metadata__['productInSeasonIdSubSeasonId']?.remoteType);
    }
    set productInSeasonIdSubSeasonId(val){
    }
    // fk: true
    /** @returns {Promise<String>} */
    getProductInSeasonIdSubSeasonIdLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.SubSeason', 'productInSeasonIdSubSeasonId',  allowRemote); //  false 
    }

    /** @returns {String} */
    getProductInSeasonIdSubSeasonIdStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.SubSeason', 'productInSeasonIdSubSeasonId'); //  false 
    }

    /** @returns {Promise<SubSeason>} */
    getProductInSeasonIdSubSeasonIdEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.SubSeason', 'productInSeasonIdSubSeasonId',  allowRemote); //  false 
    }

    /** @type {string}  */
    get orderIdSupplierIdSupplierCode(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['orderIdSupplierIdSupplierCode'] : null, this.__metadata__['orderIdSupplierIdSupplierCode']?.remoteType);
    }
    set orderIdSupplierIdSupplierCode(val){
    }
    // fk: false

    /** @type {string}  */
    get orderIdSupplierId(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['orderIdSupplierId'] : null, this.__metadata__['orderIdSupplierId']?.remoteType);
    }
    set orderIdSupplierId(val){
    }
    // fk: true
    /** @returns {Promise<String>} */
    getOrderIdSupplierIdLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.Suppliers', 'orderIdSupplierId',  allowRemote); //  false 
    }

    /** @returns {String} */
    getOrderIdSupplierIdStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.Suppliers', 'orderIdSupplierId'); //  false 
    }

    /** @returns {Promise<Suppliers>} */
    getOrderIdSupplierIdEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.Suppliers', 'orderIdSupplierId',  allowRemote); //  false 
    }

    /** @type {LocalDate}  */
    get aTA(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['aTA'] : null, this.__metadata__['aTA']?.remoteType);
    }
    set aTA(val){
    }


    /** @type {LocalDate}  */
    get aTD(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['aTD'] : null, this.__metadata__['aTD']?.remoteType);
    }
    set aTD(val){
    }


    /** @type {boolean}  */
    get alertContactWithFoodRequiredTest(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['alertContactWithFoodRequiredTest'] : null, this.__metadata__['alertContactWithFoodRequiredTest']?.remoteType);
    }
    set alertContactWithFoodRequiredTest(val){
    }


    /** @type {BigDecimal}  */
    get cBM(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['cBM'] : null, this.__metadata__['cBM']?.remoteType);
    }
    set cBM(val){
    }


    /** @type {BigDecimal}  */
    get cartons(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['cartons'] : null, this.__metadata__['cartons']?.remoteType);
    }
    set cartons(val){
    }


    /** @type {LocalDate}  */
    get eTA(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['eTA'] : null, this.__metadata__['eTA']?.remoteType);
    }
    set eTA(val){
    }


    /** @type {LocalDate}  */
    get eTD(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['eTD'] : null, this.__metadata__['eTD']?.remoteType);
    }
    set eTD(val){
    }


    /** @type {string}  */
    get excludedDays(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['excludedDays'] : null, this.__metadata__['excludedDays']?.remoteType);
    }
    set excludedDays(val){
    }


    /** @type {string}  */
    get kindOfService(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['kindOfService'] : null, this.__metadata__['kindOfService']?.remoteType);
    }
    set kindOfService(val){
    }


    /** @type {BigDecimal}  */
    get margin(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['margin'] : null, this.__metadata__['margin']?.remoteType);
    }
    set margin(val){
    }


    /** @type {string}  */
    get numberOfTranche(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['numberOfTranche'] : null, this.__metadata__['numberOfTranche']?.remoteType);
    }
    set numberOfTranche(val){
    }


    /** @type {module:src/server/com/silkplm/rpc/dto/DecimalWithCurrency.DecimalWithCurrency}  */
    get orderValueInPurchasePrice(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['orderValueInPurchasePrice'] : null, this.__metadata__['orderValueInPurchasePrice']?.remoteType);
    }
    set orderValueInPurchasePrice(val){
    }


    /** @type {number}  */
    get orderedQuantityForOrderDetailsPackage(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['orderedQuantityForOrderDetailsPackage'] : null, this.__metadata__['orderedQuantityForOrderDetailsPackage']?.remoteType);
    }
    set orderedQuantityForOrderDetailsPackage(val){
    }


    /** @type {string}  */
    get packagingProductStatus(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['packagingProductStatus'] : null, this.__metadata__['packagingProductStatus']?.remoteType);
    }
    set packagingProductStatus(val){
    }


    /** @type {LocalDate}  */
    get plannedInWarehouse(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['plannedInWarehouse'] : null, this.__metadata__['plannedInWarehouse']?.remoteType);
    }
    set plannedInWarehouse(val){
    }


    /** @type {string}  */
    get ppSampleStatus(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['ppSampleStatus'] : null, this.__metadata__['ppSampleStatus']?.remoteType);
    }
    set ppSampleStatus(val){
    }


    /** @type {string}  */
    get productFullName(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['productFullName'] : null, this.__metadata__['productFullName']?.remoteType);
    }
    set productFullName(val){
    }


    /** @type {string}  */
    get productType(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['productType'] : null, this.__metadata__['productType']?.remoteType);
    }
    set productType(val){
    }


    /** @type {module:src/server/com/silkplm/rpc/dto/DecimalWithCurrency.DecimalWithCurrency}  */
    get productionCost(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['productionCost'] : null, this.__metadata__['productionCost']?.remoteType);
    }
    set productionCost(val){
    }


    /** @type {boolean}  */
    get qualityControlStatus(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['qualityControlStatus'] : null, this.__metadata__['qualityControlStatus']?.remoteType);
    }
    set qualityControlStatus(val){
    }


    /** @type {string}  */
    get quantityWarning(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['quantityWarning'] : null, this.__metadata__['quantityWarning']?.remoteType);
    }
    set quantityWarning(val){
    }


    /** @type {number}  */
    get remainsForReplenishmentForOrderDetailsPackage(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['remainsForReplenishmentForOrderDetailsPackage'] : null, this.__metadata__['remainsForReplenishmentForOrderDetailsPackage']?.remoteType);
    }
    set remainsForReplenishmentForOrderDetailsPackage(val){
    }


    /** @type {number}  */
    get requiredTestProductsStatus(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['requiredTestProductsStatus'] : null, this.__metadata__['requiredTestProductsStatus']?.remoteType);
    }
    set requiredTestProductsStatus(val){
    }

    /** @returns {Promise<String>} */
    getRequiredTestProductsStatusLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.dictionaries.RequiredTestStatus', 'requiredTestProductsStatus', allowRemote); //  true 
    }

    /** @returns {String} */
    getRequiredTestProductsStatusStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.dictionaries.RequiredTestStatus', 'requiredTestProductsStatus'); //  true 
    }

    /** @returns {Promise<RequiredTestStatus>} */
    getRequiredTestProductsStatusEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.dictionaries.RequiredTestStatus', 'requiredTestProductsStatus',  allowRemote); //  true 
    }

    /** @type {boolean}  */
    get requiredTestReport(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['requiredTestReport'] : null, this.__metadata__['requiredTestReport']?.remoteType);
    }
    set requiredTestReport(val){
    }


    /** @type {boolean}  */
    get sanepid(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['sanepid'] : null, this.__metadata__['sanepid']?.remoteType);
    }
    set sanepid(val){
    }


    /** @type {string}  */
    get shipmentSampleRemarks(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['shipmentSampleRemarks'] : null, this.__metadata__['shipmentSampleRemarks']?.remoteType);
    }
    set shipmentSampleRemarks(val){
    }


    /** @type {string}  */
    get shipmentSampleStatus(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['shipmentSampleStatus'] : null, this.__metadata__['shipmentSampleStatus']?.remoteType);
    }
    set shipmentSampleStatus(val){
    }


    /** @type {string}  */
    get sizeRangeForBottomText(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['sizeRangeForBottomText'] : null, this.__metadata__['sizeRangeForBottomText']?.remoteType);
    }
    set sizeRangeForBottomText(val){
    }


    /** @type {string}  */
    get stickerWCLStatus(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['stickerWCLStatus'] : null, this.__metadata__['stickerWCLStatus']?.remoteType);
    }
    set stickerWCLStatus(val){
    }


    /** @type {number}  */
    get totalQuantity(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['totalQuantity'] : null, this.__metadata__['totalQuantity']?.remoteType);
    }
    set totalQuantity(val){
    }


    /** @type {number}  */
    get totalQuantityForOrderDetailsPackage(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['totalQuantityForOrderDetailsPackage'] : null, this.__metadata__['totalQuantityForOrderDetailsPackage']?.remoteType);
    }
    set totalQuantityForOrderDetailsPackage(val){
    }


    /** @type {number}  */
    get wMS(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['wMS'] : null, this.__metadata__['wMS']?.remoteType);
    }
    set wMS(val){
    }


    /** @type {LocalDate}  */
    get wMSEstimation(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['wMSEstimation'] : null, this.__metadata__['wMSEstimation']?.remoteType);
    }
    set wMSEstimation(val){
    }


    /** @type {number}  */
    get wMSEstimationWeek(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['wMSEstimationWeek'] : null, this.__metadata__['wMSEstimationWeek']?.remoteType);
    }
    set wMSEstimationWeek(val){
    }


    /** @type {string}  */
    get warningWMSEstimation(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['warningWMSEstimation'] : null, this.__metadata__['warningWMSEstimation']?.remoteType);
    }
    set warningWMSEstimation(val){
    }


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/OrderDetails.OrderDetails}
     */
    withEID(val){
        this.EID = val;
        return this;
    };


    /**
     * @param val {LocalDate}
     * @returns {module:src/server/com/silkplm/model/plm/OrderDetails.OrderDetails}
     */
    withETA(val){
        let rawValue = val;
        let v = val;
        v = new LocalDate(); v.value = rawValue;
        this.ETA = v;
        return this;
    };


    /**
     * @param val {LocalDate}
     * @returns {module:src/server/com/silkplm/model/plm/OrderDetails.OrderDetails}
     */
    withETD(val){
        let rawValue = val;
        let v = val;
        v = new LocalDate(); v.value = rawValue;
        this.ETD = v;
        return this;
    };


    /**
     * @param val {LocalDate}
     * @returns {module:src/server/com/silkplm/model/plm/OrderDetails.OrderDetails}
     */
    withEXWPI(val){
        let rawValue = val;
        let v = val;
        v = new LocalDate(); v.value = rawValue;
        this.EXWPI = v;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/OrderDetails.OrderDetails}
     */
    withPM(val){
        this.PM = val;
        return this;
    };

    /** @returns {Promise<String>} */
    getPMLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.users.ApplicationUser', 'PM', allowRemote); //  true 
    }

    /** @returns {String} */
        getPMStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.users.ApplicationUser', 'PM'); //  true 
    }

        /** @returns {Promise<ApplicationUser>} */
    getPMEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.users.ApplicationUser', 'PM', allowRemote); //  true 
    }

    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/OrderDetails.OrderDetails}
     */
    withSKUNumber(val){
        this.SKUNumber = val;
        return this;
    };


    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/model/plm/OrderDetails.OrderDetails}
     */
    with__archived(val){
        this.__archived = val;
        return this;
    };


    /**
     * @param val {number}
     * @returns {module:src/server/com/silkplm/model/plm/OrderDetails.OrderDetails}
     */
    with__familyId(val){
        this.__familyId = val;
        return this;
    };


    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/model/plm/OrderDetails.OrderDetails}
     */
    with__hidden(val){
        this.__hidden = val;
        return this;
    };


    /**
     * @param val {number}
     * @returns {module:src/server/com/silkplm/model/plm/OrderDetails.OrderDetails}
     */
    with__parent(val){
        this.__parent = val;
        return this;
    };


    /**
     * @param val {Date}
     * @returns {module:src/server/com/silkplm/model/plm/OrderDetails.OrderDetails}
     */
    with__versionDate(val){
        let rawValue = val;
        let v = val;
        v = new Date(rawValue)
        this.__versionDate = v;
        return this;
    };


    /**
     * @param val {Object.<string, *>}
     * @returns {module:src/server/com/silkplm/model/plm/OrderDetails.OrderDetails}
     */
    with_translations(val){
        this._translations = val;
        return this;
    };


    /**
     * @param val {module:src/server/com/silkplm/model/files/FileInRepository.FileInRepository[]}
     * @returns {module:src/server/com/silkplm/model/plm/OrderDetails.OrderDetails}
     */
    withAttachments(val){
        this.attachments = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/OrderDetails.OrderDetails}
     */
    withBudgetingPlannerPMId(val){
        this.budgetingPlannerPMId = val;
        return this;
    };

    /** @returns {Promise<String>} */
    getBudgetingPlannerPMIdLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.BudgetingPlannerPM', 'budgetingPlannerPMId', allowRemote); //  true 
    }

    /** @returns {String} */
        getBudgetingPlannerPMIdStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.BudgetingPlannerPM', 'budgetingPlannerPMId'); //  true 
    }

        /** @returns {Promise<BudgetingPlannerPM>} */
    getBudgetingPlannerPMIdEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.BudgetingPlannerPM', 'budgetingPlannerPMId', allowRemote); //  true 
    }

    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/OrderDetails.OrderDetails}
     */
    withCategory(val){
        this.category = val;
        return this;
    };

    /** @returns {Promise<String>} */
    getCategoryLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.Category', 'category', allowRemote); //  true 
    }

    /** @returns {String} */
        getCategoryStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.Category', 'category'); //  true 
    }

        /** @returns {Promise<Category>} */
    getCategoryEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.Category', 'category', allowRemote); //  true 
    }

    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/OrderDetails.OrderDetails}
     */
    withColorId(val){
        this.colorId = val;
        return this;
    };

    /** @returns {Promise<String>} */
    getColorIdLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.dictionaries.Colors', 'colorId', allowRemote); //  true 
    }

    /** @returns {String} */
        getColorIdStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.dictionaries.Colors', 'colorId'); //  true 
    }

        /** @returns {Promise<Colors>} */
    getColorIdEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.dictionaries.Colors', 'colorId', allowRemote); //  true 
    }

    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/OrderDetails.OrderDetails}
     */
    withColorVersionId(val){
        this.colorVersionId = val;
        return this;
    };

    /** @returns {Promise<String>} */
    getColorVersionIdLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.ColorVersion', 'colorVersionId', allowRemote); //  true 
    }

    /** @returns {String} */
        getColorVersionIdStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.ColorVersion', 'colorVersionId'); //  true 
    }

        /** @returns {Promise<ColorVersion>} */
    getColorVersionIdEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.ColorVersion', 'colorVersionId', allowRemote); //  true 
    }

    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/OrderDetails.OrderDetails}
     */
    withCommentToShopify(val){
        this.commentToShopify = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/OrderDetails.OrderDetails}
     */
    withComponentIndexId(val){
        this.componentIndexId = val;
        return this;
    };

    /** @returns {Promise<String>} */
    getComponentIndexIdLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.dictionaries.ComponentIndex', 'componentIndexId', allowRemote); //  true 
    }

    /** @returns {String} */
        getComponentIndexIdStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.dictionaries.ComponentIndex', 'componentIndexId'); //  true 
    }

        /** @returns {Promise<ComponentIndex>} */
    getComponentIndexIdEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.dictionaries.ComponentIndex', 'componentIndexId', allowRemote); //  true 
    }

    /**
     * @param val {LocalDate}
     * @returns {module:src/server/com/silkplm/model/plm/OrderDetails.OrderDetails}
     */
    withConfirmedETD(val){
        let rawValue = val;
        let v = val;
        v = new LocalDate(); v.value = rawValue;
        this.confirmedETD = v;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/OrderDetails.OrderDetails}
     */
    withCountry(val){
        this.country = val;
        return this;
    };

    /** @returns {Promise<String>} */
    getCountryLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.dictionaries.Country', 'country', allowRemote); //  true 
    }

    /** @returns {String} */
        getCountryStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.dictionaries.Country', 'country'); //  true 
    }

        /** @returns {Promise<Country>} */
    getCountryEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.dictionaries.Country', 'country', allowRemote); //  true 
    }

    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/OrderDetails.OrderDetails}
     */
    withCurrentSelectedRegion(val){
        this.currentSelectedRegion = val;
        return this;
    };


    /**
     * @param val {LocalDate}
     * @returns {module:src/server/com/silkplm/model/plm/OrderDetails.OrderDetails}
     */
    withDateOfShipmentToTheCustomer(val){
        let rawValue = val;
        let v = val;
        v = new LocalDate(); v.value = rawValue;
        this.dateOfShipmentToTheCustomer = v;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/OrderDetails.OrderDetails}
     */
    withDefaultEAN(val){
        this.defaultEAN = val;
        return this;
    };


    /**
     * @param val {LocalDate}
     * @returns {module:src/server/com/silkplm/model/plm/OrderDetails.OrderDetails}
     */
    withDeliveryDate(val){
        let rawValue = val;
        let v = val;
        v = new LocalDate(); v.value = rawValue;
        this.deliveryDate = v;
        return this;
    };


    /**
     * @param val {LocalDate}
     * @returns {module:src/server/com/silkplm/model/plm/OrderDetails.OrderDetails}
     */
    withDeliveryDateDTW(val){
        let rawValue = val;
        let v = val;
        v = new LocalDate(); v.value = rawValue;
        this.deliveryDateDTW = v;
        return this;
    };


    /**
     * @param val {LocalDate}
     * @returns {module:src/server/com/silkplm/model/plm/OrderDetails.OrderDetails}
     */
    withDeliveryDateToNAOKOWarehouse(val){
        let rawValue = val;
        let v = val;
        v = new LocalDate(); v.value = rawValue;
        this.deliveryDateToNAOKOWarehouse = v;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/OrderDetails.OrderDetails}
     */
    withDesignerDescription(val){
        this.designerDescription = val;
        return this;
    };


    /**
     * @param val {BigDecimal}
     * @returns {module:src/server/com/silkplm/model/plm/OrderDetails.OrderDetails}
     */
    withDuty(val){
        let rawValue = val;
        let v = val;
        v = new BigDecimal(rawValue)
        this.duty = v;
        return this;
    };


    /**
     * @param val {module:src/server/com/silkplm/files/images/ImageGallery.ImageGallery}
     * @returns {module:src/server/com/silkplm/model/plm/OrderDetails.OrderDetails}
     */
    withGallery(val){
        this.gallery = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/OrderDetails.OrderDetails}
     */
    withId(val){
        this.id = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/OrderDetails.OrderDetails}
     */
    withInspection(val){
        this.inspection = val;
        return this;
    };

    /** @returns {Promise<String>} */
    getInspectionLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.dictionaries.Inspection', 'inspection', allowRemote); //  true 
    }

    /** @returns {String} */
        getInspectionStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.dictionaries.Inspection', 'inspection'); //  true 
    }

        /** @returns {Promise<Inspection>} */
    getInspectionEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.dictionaries.Inspection', 'inspection', allowRemote); //  true 
    }

    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/OrderDetails.OrderDetails}
     */
    withMerchant(val){
        this.merchant = val;
        return this;
    };

    /** @returns {Promise<String>} */
    getMerchantLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.users.ApplicationUser', 'merchant', allowRemote); //  true 
    }

    /** @returns {String} */
        getMerchantStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.users.ApplicationUser', 'merchant'); //  true 
    }

        /** @returns {Promise<ApplicationUser>} */
    getMerchantEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.users.ApplicationUser', 'merchant', allowRemote); //  true 
    }

    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/OrderDetails.OrderDetails}
     */
    withName(val){
        this.name = val;
        return this;
    };


    /**
     * @param val {LocalDate}
     * @returns {module:src/server/com/silkplm/model/plm/OrderDetails.OrderDetails}
     */
    withNewDTWDeliveryDate(val){
        let rawValue = val;
        let v = val;
        v = new LocalDate(); v.value = rawValue;
        this.newDTWDeliveryDate = v;
        return this;
    };


    /**
     * @param val {LocalDate}
     * @returns {module:src/server/com/silkplm/model/plm/OrderDetails.OrderDetails}
     */
    withNewDeliveryDateToNAOKOWarehouse(val){
        let rawValue = val;
        let v = val;
        v = new LocalDate(); v.value = rawValue;
        this.newDeliveryDateToNAOKOWarehouse = v;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/OrderDetails.OrderDetails}
     */
    withNotes(val){
        this.notes = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/OrderDetails.OrderDetails}
     */
    withOrderId(val){
        this.orderId = val;
        return this;
    };

    /** @returns {Promise<String>} */
    getOrderIdLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.Order', 'orderId', allowRemote); //  true 
    }

    /** @returns {String} */
        getOrderIdStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.Order', 'orderId'); //  true 
    }

        /** @returns {Promise<Order>} */
    getOrderIdEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.Order', 'orderId', allowRemote); //  true 
    }

    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/OrderDetails.OrderDetails}
     */
    withOrderNumber(val){
        this.orderNumber = val;
        return this;
    };


    /**
     * @param val {number}
     * @returns {module:src/server/com/silkplm/model/plm/OrderDetails.OrderDetails}
     */
    withOrderedQuantity(val){
        this.orderedQuantity = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/OrderDetails.OrderDetails}
     */
    withPlanningId(val){
        this.planningId = val;
        return this;
    };

    /** @returns {Promise<String>} */
    getPlanningIdLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.PlanningProduct', 'planningId', allowRemote); //  true 
    }

    /** @returns {String} */
        getPlanningIdStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.PlanningProduct', 'planningId'); //  true 
    }

        /** @returns {Promise<PlanningProduct>} */
    getPlanningIdEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.PlanningProduct', 'planningId', allowRemote); //  true 
    }

    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/OrderDetails.OrderDetails}
     */
    withPort(val){
        this.port = val;
        return this;
    };

    /** @returns {Promise<String>} */
    getPortLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.dictionaries.Port', 'port', allowRemote); //  true 
    }

    /** @returns {String} */
        getPortStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.dictionaries.Port', 'port'); //  true 
    }

        /** @returns {Promise<Port>} */
    getPortEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.dictionaries.Port', 'port', allowRemote); //  true 
    }

    /**
     * @param val {module:src/server/com/silkplm/rpc/dto/DecimalWithCurrency.DecimalWithCurrency}
     * @returns {module:src/server/com/silkplm/model/plm/OrderDetails.OrderDetails}
     */
    withPrice(val){
        this.price = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/OrderDetails.OrderDetails}
     */
    withProductId(val){
        this.productId = val;
        return this;
    };

    /** @returns {Promise<String>} */
    getProductIdLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.Product', 'productId', allowRemote); //  true 
    }

    /** @returns {String} */
        getProductIdStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.Product', 'productId'); //  true 
    }

        /** @returns {Promise<Product>} */
    getProductIdEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.Product', 'productId', allowRemote); //  true 
    }

    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/OrderDetails.OrderDetails}
     */
    withProductInSeasonId(val){
        this.productInSeasonId = val;
        return this;
    };

    /** @returns {Promise<String>} */
    getProductInSeasonIdLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.ProductInSeason', 'productInSeasonId', allowRemote); //  true 
    }

    /** @returns {String} */
        getProductInSeasonIdStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.ProductInSeason', 'productInSeasonId'); //  true 
    }

        /** @returns {Promise<ProductInSeason>} */
    getProductInSeasonIdEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.ProductInSeason', 'productInSeasonId', allowRemote); //  true 
    }

    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/OrderDetails.OrderDetails}
     */
    withPzNumber(val){
        this.pzNumber = val;
        return this;
    };


    /**
     * @param val {number}
     * @returns {module:src/server/com/silkplm/model/plm/OrderDetails.OrderDetails}
     */
    withPzQuantity(val){
        this.pzQuantity = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/OrderDetails.OrderDetails}
     */
    withQuantityFromCuting(val){
        this.quantityFromCuting = val;
        return this;
    };


    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/model/plm/OrderDetails.OrderDetails}
     */
    withRawMaterialsPath(val){
        this.rawMaterialsPath = val;
        return this;
    };


    /**
     * @param val {LocalDate}
     * @returns {module:src/server/com/silkplm/model/plm/OrderDetails.OrderDetails}
     */
    withRealEXW(val){
        let rawValue = val;
        let v = val;
        v = new LocalDate(); v.value = rawValue;
        this.realEXW = v;
        return this;
    };


    /**
     * @param val {module:src/server/com/silkplm/engine/entities/tracking/RecordMetadata.RecordMetadata}
     * @returns {module:src/server/com/silkplm/model/plm/OrderDetails.OrderDetails}
     */
    withRecordMetadata(val){
        this.recordMetadata = val;
        return this;
    };


    /**
     * @param val {LocalDate}
     * @returns {module:src/server/com/silkplm/model/plm/OrderDetails.OrderDetails}
     */
    withShipmentDateToProcessing(val){
        let rawValue = val;
        let v = val;
        v = new LocalDate(); v.value = rawValue;
        this.shipmentDateToProcessing = v;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/OrderDetails.OrderDetails}
     */
    withStatusShipment(val){
        this.statusShipment = val;
        return this;
    };

    /** @returns {Promise<String>} */
    getStatusShipmentLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.dictionaries.OrderDetailsShipmentStatus', 'statusShipment', allowRemote); //  true 
    }

    /** @returns {String} */
        getStatusShipmentStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.dictionaries.OrderDetailsShipmentStatus', 'statusShipment'); //  true 
    }

        /** @returns {Promise<OrderDetailsShipmentStatus>} */
    getStatusShipmentEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.dictionaries.OrderDetailsShipmentStatus', 'statusShipment', allowRemote); //  true 
    }

    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/OrderDetails.OrderDetails}
     */
    withStatusShopifyId(val){
        this.statusShopifyId = val;
        return this;
    };

    /** @returns {Promise<String>} */
    getStatusShopifyIdLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.dictionaries.StatusShopify', 'statusShopifyId', allowRemote); //  true 
    }

    /** @returns {String} */
        getStatusShopifyIdStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.dictionaries.StatusShopify', 'statusShopifyId'); //  true 
    }

        /** @returns {Promise<StatusShopify>} */
    getStatusShopifyIdEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.dictionaries.StatusShopify', 'statusShopifyId', allowRemote); //  true 
    }

    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/OrderDetails.OrderDetails}
     */
    withSubSeasonId(val){
        this.subSeasonId = val;
        return this;
    };

    /** @returns {Promise<String>} */
    getSubSeasonIdLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.SubSeason', 'subSeasonId', allowRemote); //  true 
    }

    /** @returns {String} */
        getSubSeasonIdStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.SubSeason', 'subSeasonId'); //  true 
    }

        /** @returns {Promise<SubSeason>} */
    getSubSeasonIdEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.SubSeason', 'subSeasonId', allowRemote); //  true 
    }

    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/OrderDetails.OrderDetails}
     */
    withSupplierProductId(val){
        this.supplierProductId = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/OrderDetails.OrderDetails}
     */
    withTechDetailsId(val){
        this.techDetailsId = val;
        return this;
    };

    /** @returns {Promise<String>} */
    getTechDetailsIdLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.dictionaries.TechnologicalDetails', 'techDetailsId', allowRemote); //  true 
    }

    /** @returns {String} */
        getTechDetailsIdStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.dictionaries.TechnologicalDetails', 'techDetailsId'); //  true 
    }

        /** @returns {Promise<TechnologicalDetails>} */
    getTechDetailsIdEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.dictionaries.TechnologicalDetails', 'techDetailsId', allowRemote); //  true 
    }

    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/OrderDetails.OrderDetails}
     */
    withUnitId(val){
        this.unitId = val;
        return this;
    };

    /** @returns {Promise<String>} */
    getUnitIdLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.dictionaries.Unit', 'unitId', allowRemote); //  true 
    }

    /** @returns {String} */
        getUnitIdStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.dictionaries.Unit', 'unitId'); //  true 
    }

        /** @returns {Promise<Unit>} */
    getUnitIdEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.dictionaries.Unit', 'unitId', allowRemote); //  true 
    }

    /**
     * @param val {number}
     * @returns {module:src/server/com/silkplm/model/plm/OrderDetails.OrderDetails}
     */
    withVersion(val){
        this.version = val;
        return this;
    };




    /**
    * @param {string[]?} fields
    * @returns {Promise<OrderDetails>}
    */
    async save(fields){
        return this.__save(FULL_CLASS, fields);
    }

    async load(id=null){
        if(id == null){
            id = this.id;
        }
        let newVersion = await loadOrderDetails(id);
        for(const k in newVersion){
            this[k] = newVersion[k];
        }
    }
    /**
     * @return {Promise}
     */
    async delete(){
        return Rpc.Forms.deleteEntity(FULL_CLASS, this.id);
    }
    /**
     * @param {*|string} replacementIdOrInst
     * @return {Promise}
     */
    async deleteWithReplacement(replacementIdOrInst){
        if(replacementIdOrInst.hasOwnProperty('id')){
            replacementIdOrInst = replacementIdOrInst.id;
        }
        return Rpc.Forms.deleteEntityWithReplacement(FULL_CLASS, this.id, replacementIdOrInst);
    }
    /**
     * CAN_DELETE | SUGGEST_REPLACEMENT | FORCE_REPLACEMENT | DELETE_RESTRICTED | DELETE_NOT_PERMITTED
     * @return {Promise<String>>}
     */
    async canDelete(){
        return Rpc.Forms.canDeleteEntity(FULL_CLASS, this.id);
    }

    /**
     * @param fieldName
     * @returns {Promise<FieldValidationResult>}
     */
    async validateField(fieldName){
        return Rpc.Forms.validateField(FULL_CLASS, fieldName, this[fieldName], this.id);
    }

    /**
     * @returns {Promise<InputValidationResult>}
     */
    async checkConstraints(){
        return Rpc.Forms.checkConstraints(FULL_CLASS, this);
    }
    /** @returns {Promise<String>}*/
    async getFkFieldLabel(fiendName, allowRemote=false) {
        if(fiendName === 'productInSeasonIdSeasonId'){
            return this.getProductInSeasonIdSeasonIdLabel(allowRemote);
        }
        if(fiendName === 'productInSeasonIdSubSeasonId'){
            return this.getProductInSeasonIdSubSeasonIdLabel(allowRemote);
        }
        if(fiendName === 'orderIdSupplierId'){
            return this.getOrderIdSupplierIdLabel(allowRemote);
        }
        if(fiendName === 'PM'){
            return this.getPMLabel(allowRemote);
        }
        if(fiendName === 'budgetingPlannerPMId'){
            return this.getBudgetingPlannerPMIdLabel(allowRemote);
        }
        if(fiendName === 'category'){
            return this.getCategoryLabel(allowRemote);
        }
        if(fiendName === 'colorId'){
            return this.getColorIdLabel(allowRemote);
        }
        if(fiendName === 'colorVersionId'){
            return this.getColorVersionIdLabel(allowRemote);
        }
        if(fiendName === 'componentIndexId'){
            return this.getComponentIndexIdLabel(allowRemote);
        }
        if(fiendName === 'country'){
            return this.getCountryLabel(allowRemote);
        }
        if(fiendName === 'inspection'){
            return this.getInspectionLabel(allowRemote);
        }
        if(fiendName === 'merchant'){
            return this.getMerchantLabel(allowRemote);
        }
        if(fiendName === 'orderId'){
            return this.getOrderIdLabel(allowRemote);
        }
        if(fiendName === 'planningId'){
            return this.getPlanningIdLabel(allowRemote);
        }
        if(fiendName === 'port'){
            return this.getPortLabel(allowRemote);
        }
        if(fiendName === 'productId'){
            return this.getProductIdLabel(allowRemote);
        }
        if(fiendName === 'productInSeasonId'){
            return this.getProductInSeasonIdLabel(allowRemote);
        }
        if(fiendName === 'statusShipment'){
            return this.getStatusShipmentLabel(allowRemote);
        }
        if(fiendName === 'statusShopifyId'){
            return this.getStatusShopifyIdLabel(allowRemote);
        }
        if(fiendName === 'subSeasonId'){
            return this.getSubSeasonIdLabel(allowRemote);
        }
        if(fiendName === 'techDetailsId'){
            return this.getTechDetailsIdLabel(allowRemote);
        }
        if(fiendName === 'unitId'){
            return this.getUnitIdLabel(allowRemote);
        }
        if(fiendName === 'requiredTestProductsStatus'){
            return this.getRequiredTestProductsStatusLabel(allowRemote);
        }

        return '';
    }

    /** @returns {Promise<*>}*/
    async getFkFieldEntity(fiendName, allowRemote=false) {
        if(fiendName === 'PM'){
            return this.getPMEntity(allowRemote);
        }
        if(fiendName === 'budgetingPlannerPMId'){
            return this.getBudgetingPlannerPMIdEntity(allowRemote);
        }
        if(fiendName === 'category'){
            return this.getCategoryEntity(allowRemote);
        }
        if(fiendName === 'colorId'){
            return this.getColorIdEntity(allowRemote);
        }
        if(fiendName === 'colorVersionId'){
            return this.getColorVersionIdEntity(allowRemote);
        }
        if(fiendName === 'componentIndexId'){
            return this.getComponentIndexIdEntity(allowRemote);
        }
        if(fiendName === 'country'){
            return this.getCountryEntity(allowRemote);
        }
        if(fiendName === 'inspection'){
            return this.getInspectionEntity(allowRemote);
        }
        if(fiendName === 'merchant'){
            return this.getMerchantEntity(allowRemote);
        }
        if(fiendName === 'orderId'){
            return this.getOrderIdEntity(allowRemote);
        }
        if(fiendName === 'planningId'){
            return this.getPlanningIdEntity(allowRemote);
        }
        if(fiendName === 'port'){
            return this.getPortEntity(allowRemote);
        }
        if(fiendName === 'productId'){
            return this.getProductIdEntity(allowRemote);
        }
        if(fiendName === 'productInSeasonId'){
            return this.getProductInSeasonIdEntity(allowRemote);
        }
        if(fiendName === 'statusShipment'){
            return this.getStatusShipmentEntity(allowRemote);
        }
        if(fiendName === 'statusShopifyId'){
            return this.getStatusShopifyIdEntity(allowRemote);
        }
        if(fiendName === 'subSeasonId'){
            return this.getSubSeasonIdEntity(allowRemote);
        }
        if(fiendName === 'techDetailsId'){
            return this.getTechDetailsIdEntity(allowRemote);
        }
        if(fiendName === 'unitId'){
            return this.getUnitIdEntity(allowRemote);
        }
        return null;
    }


    /**
     * @param {string} externalSystemName
     * @returns {Promise<string>}
     */
    async externalId(externalSystemName){
        //clazzName, silkId, extSystem
        return Rpc.Integrations.silkIdToExternalId(FULL_CLASS, this.id, externalSystemName);
    }

    /**
     * @param {string} externalSystemName
     * @param {string} externalId
     * @returns {Promise<>}
     */
    async loadByExternalId(externalSystemName, externalId){
    //clazzName, silkId, extSystem
        let res = await Rpc.Integrations.externalIdToSilk(FULL_CLASS, externalId, externalSystemName);
        if(res.recordStatus !== "EXISTS"){
            throw new RpcNotFoundException({originalMessage:`Record status: ${res.recordStatus}`});
        }
        await this.load(res.silkId);
    }

    /**
     * @param {string} externalSystemName
     * @param {string} externalId
     * @returns {Promise<>}
     */
    async bindExternalId(externalSystemName, externalId){
      //clazzName, extId, extSystem, silkId
      return Rpc.Integrations.setMapping(FULL_CLASS, externalId, externalSystemName, this.id);
   }

    /**
     * @param {string} externalSystemName
     * @param {string} externalId
     * @returns {Promise<>}
     */
    async removeExternalId(externalSystemName, externalId){
        //clazzName, silkId, extSystem
        return Rpc.Integrations.clearMapping(FULL_CLASS, externalId, externalSystemName, this.id);
    }

    /**
     * @param {string} externalSystemName
     * @param {string} keyName
     * @returns {Promise<string>}
     */
    async readBoundValue(externalSystemName, keyName){
      let res = await Rpc.Integrations.readObjectData(FULL_CLASS, this.id, externalSystemName, keyName);
      return JSON.parse(res);
    }

    /**
     * @param {string} externalSystemName
     * @param {string} keyName
     * @param {Object} val
     * @returns {Promise<>}
     */
    async bindValue(externalSystemName, keyName, val){
      return Rpc.Integrations.storeObjectData(FULL_CLASS, externalSystemName, this.id, keyName, val);
    }

    /** @returns {string} */
    getRemoteClass(){
        return FULL_CLASS;
    }
}

/**
 * @param {string} id
 * @param {boolean?} loadFkObjects
 * @returns {Promise<OrderDetails>}
 */
async function loadOrderDetails(id, loadFkObjects){
    if(loadFkObjects){
        return Rpc.Forms.getExtendedEntity(FULL_CLASS, id);
    }
    return Rpc.Forms.getEntity(FULL_CLASS, id);
}

/**
 * @returns {Promise<OrderDetails[]>}
 */
async function listOrderDetails(){
    return Rpc.Forms.listEntities(FULL_CLASS);
}

/**
 * @param {string} id
 * @returns {Promise<string>}
 */
async function labelOrderDetails(id){
    return Rpc.Forms.getEntityLabel(FULL_CLASS, id);
}
// STATICS --------------------------------------

/**
 * @param {string} id
 * @param {boolean?} loadDetails
 * @returns {Promise<OrderDetails>}
 */
OrderDetails.load = async function(id, loadDetails=false){
    if(loadDetails){
        return Rpc.Forms.getExtendedEntity(FULL_CLASS, id);
    }
    return Rpc.Forms.getEntity(FULL_CLASS, id);
}

/**
 * @returns {Promise<OrderDetails[]>}
 */
OrderDetails.list = async function(){
    return Rpc.Forms.listEntities(FULL_CLASS);
}

/**
 * @returns {Promise<OrderDetails[]>}
 */
OrderDetails.listExtended = async function(){
    return Rpc.Forms.listExtendedEntities(FULL_CLASS);
}

/**
 * @returns {Promise<OrderDetails[]>}
 */
OrderDetails.getRemoteClass = function(){
    return FULL_CLASS;
}

/**
 * @param {string} externalSystem
 * @param {string} extId
 * @param {boolean?} loadDetails
 * @returns {Promise<OrderDetails>}
 */
OrderDetails.loadByExternalId = async function(externalSystem, extId, loadDetails=false){

    let res = await Rpc.Integrations.externalIdToSilk(FULL_CLASS, extId, externalSystem);
    if(res.recordStatus !== "EXISTS"){
        throw new RpcNotFoundException({originalMessage:`Record status: ${res.recordStatus}`});
    }
    return OrderDetails.load(res.silkId, loadDetails);
}


// INTEGRATIONS --------------------------------

/**
 * @param {string} externalSystemName
 * @param {string} silkId
 * @returns {Promise<IdMapping>}
 */
OrderDetails.bindingFromSilkId = async function(externalSystemName, silkId){
    //clazzName, silkId, extSystem
    return Rpc.Integrations.silkIdToExternalId(FULL_CLASS, silkId, externalSystemName);
}

/**
 * @param {string} externalSystemName
 * @param {string} externalId
 * @returns {Promise<IdMapping>}
 */
OrderDetails.bindingFromExternalId = async function(externalSystemName, externalId){
    //clazzName, silkId, extSystem
    return  Rpc.Integrations.externalIdToSilk(FULL_CLASS, externalId, externalSystemName);
}

/**
 * @param {string} externalSystemName
 * @param {string} externalId
 * @param {string} silkId
 * @returns {Promise<>}
 */
OrderDetails.bindExternalId = async function(externalSystemName, externalId, silkId){
    //clazzName, extId, extSystem, silkId
    return Rpc.Integrations.setMapping(FULL_CLASS, externalId, externalSystemName, silkId);
}

/**
 * @param {string} externalSystemName
 * @param {string} externalId
 * @returns {Promise<>}
 */
OrderDetails.removeExternalId = async function(externalSystemName, externalId, silkId){
    //clazzName, silkId, extSystem
    return Rpc.Integrations.clearMapping(FULL_CLASS, externalId, externalSystemName, silkId);
}

/**
 * @param {IdMapping} binding
 * @returns {Promise<>}
 */
OrderDetails.removeExternalBinding = async function(binding){
    //clazzName, silkId, extSystem
    return Rpc.Integrations.clearMapping(FULL_CLASS, binding.externalId, binding.externalSystem, binding.silkId);
}



let metadata = {};
metadata['EID'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['ETA'] = {'remoteType' : 'java.time.LocalDate', 'jsType' : 'LocalDate', 'mapped' : 'true'};
metadata['ETD'] = {'remoteType' : 'java.time.LocalDate', 'jsType' : 'LocalDate', 'mapped' : 'true'};
metadata['EXWPI'] = {'remoteType' : 'java.time.LocalDate', 'jsType' : 'LocalDate', 'mapped' : 'true'};
metadata['PM'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['SKUNumber'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['__archived'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['__familyId'] = {'remoteType' : 'number', 'jsType' : 'number', 'mapped' : 'false'};
metadata['__hidden'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['__parent'] = {'remoteType' : 'number', 'jsType' : 'number', 'mapped' : 'false'};
metadata['__versionDate'] = {'remoteType' : 'java.time.Instant', 'jsType' : 'Date', 'mapped' : 'true'};
metadata['_translations'] = {'remoteType' : 'Object.<string, *>', 'jsType' : 'Object.<string, *>', 'mapped' : 'false'};
metadata['attachments'] = {'remoteType' : 'module:src/server/com/silkplm/model/files/FileInRepository.FileInRepository[]', 'jsType' : 'module:src/server/com/silkplm/model/files/FileInRepository.FileInRepository[]', 'mapped' : 'false'};
metadata['budgetingPlannerPMId'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['category'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['colorId'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['colorVersionId'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['commentToShopify'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['componentIndexId'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['confirmedETD'] = {'remoteType' : 'java.time.LocalDate', 'jsType' : 'LocalDate', 'mapped' : 'true'};
metadata['country'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['currentSelectedRegion'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['dateOfShipmentToTheCustomer'] = {'remoteType' : 'java.time.LocalDate', 'jsType' : 'LocalDate', 'mapped' : 'true'};
metadata['defaultEAN'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['deliveryDate'] = {'remoteType' : 'java.time.LocalDate', 'jsType' : 'LocalDate', 'mapped' : 'true'};
metadata['deliveryDateDTW'] = {'remoteType' : 'java.time.LocalDate', 'jsType' : 'LocalDate', 'mapped' : 'true'};
metadata['deliveryDateToNAOKOWarehouse'] = {'remoteType' : 'java.time.LocalDate', 'jsType' : 'LocalDate', 'mapped' : 'true'};
metadata['designerDescription'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['duty'] = {'remoteType' : 'java.math.BigDecimal', 'jsType' : 'BigDecimal', 'mapped' : 'true'};
metadata['gallery'] = {'remoteType' : 'module:src/server/com/silkplm/files/images/ImageGallery.ImageGallery', 'jsType' : 'module:src/server/com/silkplm/files/images/ImageGallery.ImageGallery', 'mapped' : 'false'};
metadata['id'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['inspection'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['merchant'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['name'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['newDTWDeliveryDate'] = {'remoteType' : 'java.time.LocalDate', 'jsType' : 'LocalDate', 'mapped' : 'true'};
metadata['newDeliveryDateToNAOKOWarehouse'] = {'remoteType' : 'java.time.LocalDate', 'jsType' : 'LocalDate', 'mapped' : 'true'};
metadata['notes'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['orderId'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['orderNumber'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['orderedQuantity'] = {'remoteType' : 'number', 'jsType' : 'number', 'mapped' : 'false'};
metadata['planningId'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['port'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['price'] = {'remoteType' : 'module:src/server/com/silkplm/rpc/dto/DecimalWithCurrency.DecimalWithCurrency', 'jsType' : 'module:src/server/com/silkplm/rpc/dto/DecimalWithCurrency.DecimalWithCurrency', 'mapped' : 'false'};
metadata['productId'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['productInSeasonId'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['pzNumber'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['pzQuantity'] = {'remoteType' : 'number', 'jsType' : 'number', 'mapped' : 'false'};
metadata['quantityFromCuting'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['rawMaterialsPath'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['realEXW'] = {'remoteType' : 'java.time.LocalDate', 'jsType' : 'LocalDate', 'mapped' : 'true'};
metadata['recordMetadata'] = {'remoteType' : 'module:src/server/com/silkplm/engine/entities/tracking/RecordMetadata.RecordMetadata', 'jsType' : 'module:src/server/com/silkplm/engine/entities/tracking/RecordMetadata.RecordMetadata', 'mapped' : 'false'};
metadata['shipmentDateToProcessing'] = {'remoteType' : 'java.time.LocalDate', 'jsType' : 'LocalDate', 'mapped' : 'true'};
metadata['statusShipment'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['statusShopifyId'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['subSeasonId'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['supplierProductId'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['techDetailsId'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['unitId'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['version'] = {'remoteType' : 'number', 'jsType' : 'number', 'mapped' : 'false'};
metadata['aTA'] = {'computed' : true, 'remoteType' : 'java.time.LocalDate', 'jsType' : 'LocalDate', 'mapped' : 'true'};
metadata['aTD'] = {'computed' : true, 'remoteType' : 'java.time.LocalDate', 'jsType' : 'LocalDate', 'mapped' : 'true'};
metadata['alertContactWithFoodRequiredTest'] = {'computed' : true, 'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['cBM'] = {'computed' : true, 'remoteType' : 'java.math.BigDecimal', 'jsType' : 'BigDecimal', 'mapped' : 'true'};
metadata['cartons'] = {'computed' : true, 'remoteType' : 'java.math.BigDecimal', 'jsType' : 'BigDecimal', 'mapped' : 'true'};
metadata['eTA'] = {'computed' : true, 'remoteType' : 'java.time.LocalDate', 'jsType' : 'LocalDate', 'mapped' : 'true'};
metadata['eTD'] = {'computed' : true, 'remoteType' : 'java.time.LocalDate', 'jsType' : 'LocalDate', 'mapped' : 'true'};
metadata['excludedDays'] = {'computed' : true, 'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['kindOfService'] = {'computed' : true, 'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['margin'] = {'computed' : true, 'remoteType' : 'java.math.BigDecimal', 'jsType' : 'BigDecimal', 'mapped' : 'true'};
metadata['numberOfTranche'] = {'computed' : true, 'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['orderValueInPurchasePrice'] = {'computed' : true, 'remoteType' : 'module:src/server/com/silkplm/rpc/dto/DecimalWithCurrency.DecimalWithCurrency', 'jsType' : 'module:src/server/com/silkplm/rpc/dto/DecimalWithCurrency.DecimalWithCurrency', 'mapped' : 'false'};
metadata['orderedQuantityForOrderDetailsPackage'] = {'computed' : true, 'remoteType' : 'number', 'jsType' : 'number', 'mapped' : 'false'};
metadata['packagingProductStatus'] = {'computed' : true, 'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['plannedInWarehouse'] = {'computed' : true, 'remoteType' : 'java.time.LocalDate', 'jsType' : 'LocalDate', 'mapped' : 'true'};
metadata['ppSampleStatus'] = {'computed' : true, 'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['productFullName'] = {'computed' : true, 'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['productType'] = {'computed' : true, 'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['productionCost'] = {'computed' : true, 'remoteType' : 'module:src/server/com/silkplm/rpc/dto/DecimalWithCurrency.DecimalWithCurrency', 'jsType' : 'module:src/server/com/silkplm/rpc/dto/DecimalWithCurrency.DecimalWithCurrency', 'mapped' : 'false'};
metadata['qualityControlStatus'] = {'computed' : true, 'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['quantityWarning'] = {'computed' : true, 'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['remainsForReplenishmentForOrderDetailsPackage'] = {'computed' : true, 'remoteType' : 'number', 'jsType' : 'number', 'mapped' : 'false'};
metadata['requiredTestProductsStatus'] = {'computed' : true, 'remoteType' : 'number', 'jsType' : 'number', 'mapped' : 'false'};
metadata['requiredTestReport'] = {'computed' : true, 'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['sanepid'] = {'computed' : true, 'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['shipmentSampleRemarks'] = {'computed' : true, 'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['shipmentSampleStatus'] = {'computed' : true, 'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['sizeRangeForBottomText'] = {'computed' : true, 'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['stickerWCLStatus'] = {'computed' : true, 'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['totalQuantity'] = {'computed' : true, 'remoteType' : 'number', 'jsType' : 'number', 'mapped' : 'false'};
metadata['totalQuantityForOrderDetailsPackage'] = {'computed' : true, 'remoteType' : 'number', 'jsType' : 'number', 'mapped' : 'false'};
metadata['wMS'] = {'computed' : true, 'remoteType' : 'number', 'jsType' : 'number', 'mapped' : 'false'};
metadata['wMSEstimation'] = {'computed' : true, 'remoteType' : 'java.time.LocalDate', 'jsType' : 'LocalDate', 'mapped' : 'true'};
metadata['wMSEstimationWeek'] = {'computed' : true, 'remoteType' : 'number', 'jsType' : 'number', 'mapped' : 'false'};
metadata['warningWMSEstimation'] = {'computed' : true, 'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['colorVersionIdColorVersionNumber'] = {'computed' : true, 'remoteType' : 'number', 'jsType' : 'number', 'mapped' : 'false'};
metadata['orderIdDateOfOrderDispatch'] = {'computed' : true, 'remoteType' : 'java.time.LocalDate', 'jsType' : 'LocalDate', 'mapped' : 'true'};
metadata['orderIdNumberOfOrder'] = {'computed' : true, 'remoteType' : 'number', 'jsType' : 'number', 'mapped' : 'false'};
metadata['productInSeasonIdProductIdNumberOfProduct'] = {'computed' : true, 'remoteType' : 'number', 'jsType' : 'number', 'mapped' : 'false'};
metadata['orderIdOrderForRawMaterials'] = {'computed' : true, 'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['productInSeasonIdSeasonId'] = {'computed' : true, 'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['productInSeasonIdSubSeasonId'] = {'computed' : true, 'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['orderIdSupplierIdSupplierCode'] = {'computed' : true, 'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['orderIdSupplierId'] = {'computed' : true, 'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};

metadata.__type__ = 'com.silkplm.model.plm.OrderDetails';
metadata.__type_short__ = 'OrderDetails';
OrderDetails.prototype.__metadata__ = metadata;

OrderDetails.prototype.__cls__ = FULL_CLASS;

/** @module src/server/com/silkplm/model/plm/OrderDetails */
export default OrderDetails

export { OrderDetails , loadOrderDetails, listOrderDetails, labelOrderDetails }
